import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=c3bcb7dc&scoped=true&"
import script from "./ItemCreate.vue?vue&type=script&lang=js&"
export * from "./ItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./ItemCreate.vue?vue&type=style&index=0&id=c3bcb7dc&prod&lang=scss&"
import style1 from "./ItemCreate.vue?vue&type=style&index=1&id=c3bcb7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bcb7dc",
  null
  
)

export default component.exports